import { styled } from "@mui/material";
import { rem } from "polished";

export const ExpenseTypeAmountLabel = styled("div")`
  color: ${(props) => props.theme.palette.primary.contrastText};
  font-size: ${rem(13)};
`;
